import React from 'react';
import { graphql } from 'gatsby';

import BaseLayout from '../layouts/base-layout';
import CollectionsGrid from '../components/collections/collections-grid';
import GridHeader from '../components/common/grid-header';
import HeadWrapper from '../components/layout/head-wrapper';
import PageTitle from '../components/common/page-title';

import EssayGrid from "../components/essays/essay-grid";

export const Head = ({ data }) => (
	<HeadWrapper
		title={`${data.tag.data.Label} — Tag`}
	>
		<meta
			id="metaTitle"
			name="title"
			content={`${data.tag.data.Label} — Tag`}
		/>
		<meta
			id="ogTitle"
			property="og:title"
			content={`${data.tag.data.Label} — Tag`}
		/>
		<meta
			id="ogUrl"
			property="og:url"
			content={`https://publicdomainreview.org/tag/${data.tag.data.Slug}/`}
		/>
	</HeadWrapper>
);

class TagPage extends React.Component {
  constructor(props) {
    super(props);

    this.wrapCollections = this.wrapCollections.bind(this);
    this.wrapEssays = this.wrapEssays.bind(this);

    this.wrappedCollections = this.wrapCollections();
    this.wrappedEssays = this.wrapEssays();
  }

  wrapCollections() {
    if (this.props.data.collections.data.Collections) {
      const publishedCollections = this.props.data.collections.data.Collections.filter(({ data }) => data.Published );
      return { edges: publishedCollections.map(({ data }) => { return { node: { data: data }} }) };
    }


    return { edges: [] };
  }

  wrapEssays() {
    if (this.props.data.essays.data.Essays) {
      const publishedEssays = this.props.data.essays.data.Essays.filter(({ data }) => data.Published );
      return { edges: publishedEssays.map(({ data }) => { return { node: { data: data }} }) };
    }

    return { edges: [] };
  }

  render() {
    return (
      <BaseLayout path={this.props.location.pathname}>
        <div className="page-width">
          <PageTitle title="Tags" to="/tags" subtitle={this.props.data.tag.data.Label} />
        </div>

        {(this.wrappedCollections.edges.length > 0) ? (
          <div className="section-spaced-row page-width">
            <GridHeader title="Collections" />
            <CollectionsGrid collections={this.wrappedCollections.edges} />
          </div>
        ) : null}

        {(this.wrappedEssays.edges.length > 0) ? (
          <div className="section-spaced-row page-width">
            <GridHeader title="Essays" />
            <EssayGrid essayEdges={this.wrappedEssays.edges} />
          </div>
        ) : null}
      </BaseLayout>
    );
  }
}

export default TagPage;

export const query = graphql`
query ($tag: String) {
  tag: airtable(table: {eq: "Tags"}, data: {Slug: {eq: $tag}}) {
    data {
      Label
      Slug
    }
  }
  collections: airtable(table: {eq: "Tags"}, data: {Slug: {eq: $tag}}) {
    data {
      Collections {
        data {
          Title
          Slug
          Medium
          Theme
          Published_Date
          Featured_Image_Path
          Published
        }
      }
    }
  }
  essays: airtable(table: {eq: "Tags"}, data: {Slug: {eq: $tag}}) {
    data {
      Essays {
        data {
          Title
          Slug
          Intro
          Published_Date
          Featured_Image_Path
          Published
          Contributors {
            data {
              Name
              Slug
            }
          }
        }
      }
    }
  }
}
`;
